import { Api } from './api';

export class CollectionsApi {
    private static readonly PATH = '/collections';

    constructor(private readonly m_api: Api) {}

    public async get() {
        return this.m_api.get(CollectionsApi.PATH);
    }

    public async complete(collectionId: number) {
        return this.m_api.post(`${CollectionsApi.PATH}/complete`, { collectionId });
    }
}